<style>
  .sp-form-field {
    margin: 24px 0 0;
  }

  .description {
    margin: 4px 0 20px;
    color: #475467;
    font-size: 13px;
    font-style: italic;
    line-height: 1.5;
  }

  .warning {
    color: red;
  }

  mat-form-field {
    width: 100%;
  }

  .radiobuttonmargin {
    margin: 0 20px 10px 0;
  }

  .search-input-wrapper {
    padding: 8px 16px;
    display: flex;
    align-items: center;
  }

  .search-input {
    width: 100%;
    border: none;
    outline: none;
    font-size: 16px;
  }

  .search-input-wrapper:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .payment-reciever-loading {
    opacity: 0.55;
  }

  .payment-reciever-header {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .payment-reciever-header h2 {
    margin: 0;
    color: #111827;
    font-size: 20px;
    font-weight: 700;
  }

  .payment-reciever-select-container {
    flex: 1 1 auto;
    min-width: 0;
  }

  .payment-reciever-spinner {
    display: flex;
    align-items: center;
    min-width: 24px;
  }

  .dialog-field {
    width: 100%;
    display: block;
  }

  .dialog-field-row {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
    gap: 16px;
    align-items: start;
  }

  .dialog-section {
    margin-top: 24px;
    padding-top: 20px;
    border: 0;
    border-top: 1px solid #dfe4ec;
    border-radius: 0;
  }

  .dialog-section h3 {
    margin: 0 0 4px;
    color: #111827;
    font-size: 17px;
    font-weight: 700;
  }

  .dialog-row {
    margin: 0 0 16px;
    padding: 0;
  }

  .dialog-field-cell {
    min-width: 0;
  }

  .payment-reciever-select-field {
    margin-bottom: 0;
  }

  .employment-fieldset {
    margin: 0 0 16px;
    padding: 0;
    border: 0;
  }

  .employment-fieldset legend {
    margin-bottom: 12px;
    color: #111827;
    font-size: 14px;
    font-weight: 700;
  }

  .employment-options {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  :host ::ng-deep .dialog-field .mat-form-field-flex,
  :host ::ng-deep .dialog-field .mat-mdc-text-field-wrapper {
    min-height: 56px;
    padding: 0 12px !important;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: var(--sam-input-background, #f7f7f7);
    box-sizing: border-box;
  }

  :host ::ng-deep .dialog-field .mat-form-field-infix,
  :host ::ng-deep .dialog-field .mat-mdc-form-field-infix {
    min-height: 56px;
    padding-top: 20px;
    padding-bottom: 6px;
    border-top: 0;
  }

  :host ::ng-deep .dialog-field .mat-form-field-underline,
  :host ::ng-deep .dialog-field .mdc-line-ripple::before,
  :host ::ng-deep .dialog-field .mdc-line-ripple::after {
    display: none !important;
  }

  :host ::ng-deep .dialog-field .mat-mdc-form-field-subscript-wrapper,
  :host ::ng-deep .dialog-field .mat-form-field-subscript-wrapper {
    display: none !important;
  }

  :host ::ng-deep .payment-reciever-select-field .mat-form-field-infix,
  :host ::ng-deep .payment-reciever-select-field .mat-mdc-form-field-infix {
    padding-top: 20px;
    padding-bottom: 6px;
    min-height: 52px;
  }

  :host ::ng-deep .payment-reciever-select-field .mat-select-trigger,
  :host ::ng-deep .payment-reciever-select-field .mat-mdc-select-trigger {
    margin-top: 0;
  }

  :host ::ng-deep .dialog-field textarea.mat-input-element {
    min-height: 72px;
    margin-top: 0;
    resize: vertical;
  }

  :host ::ng-deep .info {
    color: var(--sam-accent-color, #005c96) !important;
  }

  .add-reciever-button {
    flex: 0 0 48px;
    color: var(--sam-accent-color, #005c96);
  }

  .dialog-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .dialog-actions button {
    min-width: 120px;
    height: 44px !important;
    min-height: 44px;
    margin: 0 !important;
    padding: 0 18px;
    border-radius: 999px !important;
    box-shadow: 0 3px 10px rgba(20, 36, 63, 0.1) !important;
    font-size: 14px;
    font-weight: 600;
    line-height: 44px;
    transition: box-shadow 150ms ease, transform 150ms ease;
  }

  .dialog-actions button:not(:disabled):hover {
    box-shadow: 0 5px 14px rgba(20, 36, 63, 0.13) !important;
    transform: translateY(-1px);
  }

  .dialog-actions .dialog-save-button:not(:disabled) {
    border-color: var(--sam-accent-color, #005c96) !important;
    color: #ffffff !important;
    background: var(--sam-accent-color, #005c96) !important;
  }

  .dialog-actions button:disabled {
    box-shadow: none !important;
    transform: none;
  }

  @media only screen and (max-width: 768px) {
    .dialog-field-row {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
</style>

<form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
  <div class="col-12" style="padding:0;">
    <div class="payment-reciever-header">
      <h2>Betalmottagare</h2>
    </div>
    <div class="description">Välj vilka som ska få lön/betalning i fakturaunderlaget</div>
    <div class="d-flex align-items-center" [class.payment-reciever-loading]="isLoadingPaymentRecievers">
      <div class="payment-reciever-select-container">
        <mat-form-field floatLabel="always" class="dialog-field payment-reciever-select-field">
          <mat-label>Välj betalmottagare ({{selectedPaymentRecieverKeys.length}})</mat-label>
          <mat-select class="select-paymentreciever"
                      style="color: black;"
                      name="paymentrecievers"
                      [disabled]="isLoadingPaymentRecievers"
                      [ngModel]="selectedPaymentRecieverKeys"
                      (ngModelChange)="onPaymentRecieverSelectionChange($event)"
                      [compareWith]="comparePaymentRecieverSelection"
                      multiple
                      (openedChange)="resetSearchTerm($event)">
            <mat-select-trigger>{{ getSelectedPaymentRecieverTriggerText() }}</mat-select-trigger>

            <div class="search-input-wrapper">
              <input matInput
                     placeholder="Sök..."
                     [(ngModel)]="searchTerm"
                     (ngModelChange)="filterPaymentReceivers()"
                     autocomplete="off"
                     name="searchterm"
                     class="search-input">
            </div>

            <div class="search-input-wrapper" *ngIf="!isLoadingPaymentRecievers && filteredPaymentRecievers.length === 0" disabled>
              Inga användare hittades
            </div>

            <ng-container *ngFor="let item of filteredPaymentRecievers">
              <mat-option [value]="getPaymentRecieverSelectionValue(item)"
                          [selected]="isPaymentRecieverSelected(item)"
                          (onSelectionChange)="onPaymentRecieverOptionSelectionChange(item, $event.source.selected, $event.isUserInput)">
                {{item.FirstName}} {{item.LastName}} ({{item.PersonalNumber}})
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="payment-reciever-spinner" *ngIf="isLoadingPaymentRecievers" style="margin-left: 10px;">
        <mat-spinner diameter="18" color="accent"></mat-spinner>
      </div>

      <button type="button" mat-icon-button class="add-reciever-button" aria-label="Lägg till ny ersättningsmottagare" matTooltip="Lägg till ny ersättningsmottagare" (click)="createSalaryReciever($event)">
        <mat-icon>person_add</mat-icon>
      </button>
    </div>
  </div>

  <section class="dialog-section">
    <h3>Information</h3>
    <div class="description">
      Lägg till information som gäller för alla betalningsmottagare. Individuell information kan läggas till och redigeras i grundvyn.
    </div>

  <div class="col-12 row dialog-row">
    <mat-form-field floatLabel="always" class="dialog-field">
      <mat-label>Beskrivning</mat-label>
      <textarea matInput
                rows="3"
                [(ngModel)]="invoiceGroupTemplate.Description"
                id="message"
                name="description-quick-add"></textarea>
    </mat-form-field>
  </div>

  <fieldset class="employment-fieldset">
    <legend>Anställningsform</legend>
    <mat-radio-group class="employment-options" name="employmentType" [(ngModel)]="invoiceGroupTemplate.EmploymentTypeId">
      <mat-radio-button class="ml-2 radiobuttonmargin" [value]="2">Egenanställd <mat-icon color="accent" class="info" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Personen är egenanställd via SAMpoolen. Den egenanställda betalar själv serviceavgiften.">info</mat-icon></mat-radio-button>
      <mat-radio-button class="ml-2 radiobuttonmargin" [value]="1">Bemanning <mat-icon color="accent" class="info" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Personen är anställd av SAMgruppen på uppdrag av dig. Uppdragsgivaren betalar vår serviceavgift.">info</mat-icon></mat-radio-button>
      <mat-radio-button class="ml-2 radiobuttonmargin" [value]="3">Konsult/företagare/enskild firma <mat-icon color="accent" class="info" matTooltipPosition="after" area-label="Hover to display info" matTooltip="Uppdragstagaren är egen företagare. Ingen serviceavgift.">info</mat-icon></mat-radio-button>
    </mat-radio-group>
  </fieldset>

  <div class="col-12 row dialog-row">
    <div class="dialog-field-row">
      <div class="dialog-field-cell">
        <mat-form-field floatLabel="always" class="dialog-field">
          <mat-label>Belopp (ex moms)</mat-label>
          <input type="number"
                 matInput
                 [(ngModel)]="invoiceGroupTemplate.Amount"
                 id="commission"
                 name="commission">
        </mat-form-field>
      </div>

      <div class="dialog-field-cell">
        <mat-form-field floatLabel="always" class="dialog-field">
          <mat-label>Moms *</mat-label>
          <mat-select required [(ngModel)]="invoiceGroupTemplate.Vat" name="rowvatselected">
            <ng-container *ngFor="let item of vatList | slice:0:3">
              <mat-option value="{{item.Value}}">{{item.Value}} %</mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  </section>

  <div class="col-sm-12 sp-form-field dialog-actions">
    <button type="button" mat-stroked-button class="dialog-cancel-button" (click)="cancel()">Avbryt</button>
    <button type="submit" mat-raised-button class="dialog-save-button" [disabled]="!f.form.valid" color="primary">Spara</button>
  </div>
</form>
